import { WSService } from "../../../../utils/WSService";

export const meridioPlanCatalogService = new WSService(
  "/v2/benefits/meridio/plan-catalog"
);
